export default __webpack_public_path__ + "static/media/AvatarKids-16.8fad4a26.png";